import { render, staticRenderFns } from "./public-edit-quiz.html?vue&type=template&id=6f08f994&scoped=true&"
import script from "./public-edit-quiz.js?vue&type=script&lang=js&"
export * from "./public-edit-quiz.js?vue&type=script&lang=js&"
import style0 from "./public-edit-quiz.scss?vue&type=style&index=0&id=6f08f994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f08f994",
  null
  
)

export default component.exports